<template>
    <div v-if="visible" class="modal-backdrop" @click.self="close">
        <div class="modal-content">
            <Login :allowGuest="allowGuest" :hideTitle="true" :allowEmailLogin="allowEmailLogin" :allowSignup="allowSignup" />
        </div>
    </div>
</template>

<script setup>
    import Login from './Login.vue'
    const props = defineProps({ visible: Boolean, allowGuest: Boolean, allowEmailLogin: Boolean, allowSignup: Boolean })
    const emit = defineEmits(['close'])

    const close = () => emit('close')
</script>

<style scoped>
    .modal-backdrop {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0.5);
        z-index: 1200;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .modal-content {
        background: #3b094ced;
        border-radius: 10px;
        padding: 2rem;
        max-width: 400px;
        width: 100%;
    }
</style>
